export default __webpack_public_path__ + "static/media/qr-bridge-dev.498188cc.png";